import { useEffect } from "react"
import { useLocation } from "react-router-dom";

const Login = () => {
    const search = useLocation().search;
    useEffect(() => {
        console.log(new URLSearchParams(search))
        const code = new URLSearchParams(search).get('code');
        console.log(code)
    }, [])
    return (
        <div></div>
    )
}
export default Login